import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Frame from '../components/Frame.tsx';
import AreaChart from '../components/AreaChart';
import appleStock from '../data/stock';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "area-chart"
    }}>{`Area Chart`}</h1>
    <p>{`See the component `}<a parentName="p" {...{
        "href": "https://github.com/kristw/encodable/tree/master/packages/docs/src/components/AreaChart"
      }}>{`source code`}</a>{`.
or play with the component API by editing the code below.`}</p>

    <Playground __position={0} __code={'<Frame width={360} height={270} background=\"transparent\">\n  <AreaChart\n    width={360}\n    height={270}\n    encoding={{\n      x: { type: \'temporal\', field: \'date\', scale: { type: \'utc\' } },\n      y: { type: \'quantitative\', field: \'close\' },\n    }}\n    data={appleStock}\n  />\n</Frame>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Frame,
      AreaChart,
      appleStock,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Frame width={360} height={270} background="transparent" mdxType="Frame">
    <AreaChart width={360} height={270} encoding={{
          x: {
            type: 'temporal',
            field: 'date',
            scale: {
              type: 'utc'
            }
          },
          y: {
            type: 'quantitative',
            field: 'close'
          }
        }} data={appleStock} mdxType="AreaChart" />
  </Frame>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      